/**
 * Generates a unique filename by adding timestamp and hash.
 * Prevents filename collisions during uploads.
 */
export const generateUniqueFileName = (originalName: string): string => {
  const timestamp = Date.now();
  const hash = Math.random().toString(36).substring(2, 8);
  const lastDotIndex = originalName.lastIndexOf('.');
  const name =
    lastDotIndex !== -1
      ? originalName.substring(0, lastDotIndex)
      : originalName;
  const ext = lastDotIndex !== -1 ? originalName.substring(lastDotIndex) : '';
  return `${name}_${timestamp}_${hash}${ext}`;
};

/**
 * Creates a preview URL for image files.
 * Tracks the URL in the provided Set for cleanup.
 * Returns undefined for non-image files.
 */
export const createPreviewUrl = (
  file: File,
  urlTracker: Set<string>,
): string | undefined => {
  if (!file.type.startsWith('image/')) {
    return undefined;
  }
  const url = URL.createObjectURL(file);
  urlTracker.add(url);
  return url;
};

/**
 * Revokes a preview URL and removes it from the tracker.
 */
export const revokePreviewUrl = (
  url: string | undefined,
  urlTracker: Set<string>,
): void => {
  if (url) {
    URL.revokeObjectURL(url);
    urlTracker.delete(url);
  }
};
